import createCache from '@emotion/cache';

const nonce = document
  .querySelector('meta[name="csp-nonce"]')
  ?.getAttribute('content');

const emotionCache = createCache({
  key: 'custom',
  nonce,
});

export default emotionCache;
